// The class rules a student agrees to once, on their first visit (decision 68; PRD §9 "How BuildLab
// works & rules"; CURRICULUM Meeting 1). Written for 12–14-year-olds: the reading-level test in
// apps/web/test keeps them at grade 8 or below. Paul can change the wording here.

export interface ClassRule {
  title: string;
  text: string;
}

export const RULES_INTRO = "BuildLab is our class's coding studio. Read these rules, then agree to them to start building.";

export const CLASS_RULES: ClassRule[] = [
  {
    title: "Be kind",
    text: "Build things that are kind and fit for school. No mean jokes about real people, and nothing you wouldn't show your teacher or your family.",
  },
  {
    title: "The helper is an AI, not a person",
    text: "It's a computer program. It can be wrong, so check what it builds. You are the one in charge of your project.",
  },
  {
    title: "Keep private things private",
    text: "Never type real names, addresses, phone numbers or passwords into BuildLab. That goes for yours and for anyone else's.",
  },
  {
    title: "Your teacher can see your work",
    text: "Your teacher can see your projects and every message you send to the helper. So write like your teacher is reading, because they might be.",
  },
  {
    title: "Ask for help",
    text: "Stuck? Read the helper's answer again, try Ask mode, then ask a partner. Still stuck? Ask your teacher. If anything makes you feel unsafe or upset, tell your teacher right away.",
  },
  {
    title: "Give credit",
    text: "If you use a classmate's idea or remix their project, say whose it was. Share your own ideas freely too.",
  },
];

export const RULES_AGREE = "I read the rules, and I'll follow them.";
